export default {
  NAVIGATION: {
    SERVICES: 'Dienste',
    SERVICE_SUBMISSIONS: 'Dienst Submissions',
    ALL_INCLUSIVE_SERVICES: 'Rundum Sorglos Dienste',
    TIER_SERVICES: 'Dienste nach Dringlichkeit',
    SERVICEAREAS: 'Dienstgebiete',
    USERS: 'Nutzer',
    INSURANCES: 'Versicherungen',
    ACCOUNTING: 'Buchhaltung',
    REPORTING: 'Reporting',
    LOGISTICS_HUB: 'Logistik Hub',
  },
  EXCEPTIONS: {
    NO_LICENSE: 'Die Approbation des Vertreters fehlt.',
    HEADLINE: 'Es ist ein Fehler aufgetreten.',
    DESCRIPTION: 'Der folgende Fehler ist aufgetreten: ',
    OVERLAPPING_SERVICE_OPERATOR: 'Der Vertreter ist bereits für einen anderen Dienst in diesem Zeitraum eingeteilt.',
    OVERLAPPING_SERVICE_SUBSTITUTE: 'Sie sind bereits für einen anderen Dienst in diesem Zeitraum eingeteilt.',
    SPECIALIZATION_REQUIRED: 'Wir konnten Ihre Facharzturkunde noch nicht verifizieren und Sie haben sich auf einen Dienst in einem Bundesland beworben, in dem nur noch Fachärzte Bereitschaftsdienste vertreten dürfen.',
    SPECIALIZATION_MISMATCH: 'Ihr Fachgebiet entspricht nicht den Anforderungen des Dienstes.',
    CONCLUDE_SERVICE_NOT_ENDED: 'Der Dienst kann nicht abgeschlossen werden, da er noch nicht beendet ist.',
    MOBILE_SHARE_RATE_EXCEEDED: 'Die Notfallscheinbeteiligung für Fahrdienste überschreitet den zulässigen Höchstwert.',
    OFFICE_SHARE_RATE_EXCEEDED: 'Die Notfallscheinbeteiligung für Sitzdienste überschreitet den zulässigen Höchstwert.',
    USER_NOT_IDENTIFIED: 'Der aktuelle Benutzer konnte nicht identifiziert werden.',
    CONCLUDE_NOT_ALLOWED: 'Der Abschluss von Diensten kann nur von Kunden und Operatoren durchgeführt werden.',
    INVALID_SERVICE: 'Ungültiger Dienst.',
    CONCLUDE_STILL_PUBLISHED: 'Der Dienst kann nicht abgeschlossen werden, da er noch veröffentlicht ist (noch nicht vergeben).',
    SERVICE_ALREADY_CONCLUDED: 'Der Dienst wurde bereits abgeschlossen.',
    ESTABLISHMENT_NO_INSTITUTION: 'Die Betriebsstätte gehört keiner Einrichtung an.',
    INSTITUTION_NO_OWNER: 'Die Einrichtung hat keinen zugeordneten Eigentümer.',
    CONCLUDE_NO_ASSIGNMENT: 'Der Dienst kann nicht abgeschlossen werden, da keine Zuweisung vorhanden ist.',
    MISSING_SUBSTITUTE_COUNTS: 'Die Zählungen des Vertreters fehlen.',
    DEACTIVATED_USER: 'Der Benutzer ist deaktiviert.',
    NO_PARTNER_PAYMENT_METHOD: 'Keine verfügbaren Zahlungsmethoden für den Kunden.',
    NO_SUBSTITUTE_PAYMENT_METHOD: 'Keine verfügbaren Zahlungsmethoden für den Vertreter.',
    SERVICE_DURATION_EXCEEDED: 'Die Dienstdauer überschreitet 24 Stunden.',
    SERVICE_NOT_FOUND: 'Dienst nicht gefunden.',
    MISSING_SERVICE: 'Der Dienst existiert nicht.',
    UNKNOWN_USER: 'Unbekannter Benutzer.',
    OVERLAPPING_SERVICE: 'Der Vertreter ist bereits für einen anderen Dienst in diesem Zeitraum eingeteilt.',
    SERVICE_ALREADY_ASSIGNED: 'Der Dienst wurde bereits einem Vertreter zugewiesen.',
    SERVICE_NOT_INSTANT_ASSIGNABLE: 'Der Dienst kann nicht sofort zugewiesen werden.',
    MISSING_SUBSTITUTE_ROLE: 'Dem Benutzer fehlt die Rolle „Vertreter".',
    MISSING_SUBSTITUTE_ENTRY: 'Dem Benutzer fehlt der Vertretereintrag.',
    INVALID_SUBSTITUTE: 'Ungültiger Vertreter.',
    SUBSTITUTE_CAN_ONLY_APPLY_SELF: 'Ein Vertreter kann sich nur selbst bewerben.',
    TRAINING_NOT_CONFIRMED: 'Der Vertreter hat die Absolvierung des 3. Weiterbildungsjahres nicht bestätigt.',
    SUBSTITUTE_NOT_VERIFIED: 'Der Vertreter wurde noch nicht verifiziert.',
    MISSING_LICENSE: 'Die Approbation des Vertreters fehlt.',
    SUBSTITUTE_NOT_INSURED: 'Der Vertreter ist während der Dienstlaufzeit nicht versichert.',
    ALREADY_ADDED_BY_SUBSTITUTE: 'Die Bewerbung wurde bereits vom Vertreter hinzugefügt.',
    NEGATIVE_COUNTS: 'Zählungen dürfen nicht negativ sein.',
    CONCLUDED_SERVICE: 'Die Zählungen eines abgeschlossenen Dienstes können nicht aktualisiert werden.',
    MISSING_USER_ENTRY: 'Benutzereintrag fehlt.',
    SERVICE_FEE_OUT_OF_BOUNDS: 'Das Diensthonorar liegt außerhalb des zulässigen Bereichs.',
    NO_ASSIGNMENT_CONTRACT_CONFIRM: 'Vertrag kann nicht bestätigt werden, da keine Zuweisung vorhanden ist.',
    NO_ASSIGNMENT: 'Zählungen können nicht gesetzt werden, da keine Zuweisung vorhanden ist.',
    NO_ASSIGNMENT_COUNTS_CONFIRM: 'Zählungen können nicht bestätigt werden, da keine Zuweisung vorhanden ist.',
    MIN_REGULAR_MOBILE_FEE: 'Das Mindesthonorar für reguläre Fahrdienste muss mindestens 45 betragen.',
    MIN_HOLIDAY_MOBILE_FEE: 'Das Mindesthonorar für Feiertags-Fahrdienste muss mindestens 45 betragen.',
    MIN_REGULAR_OFFICE_FEE: 'Das Mindesthonorar für reguläre Sitzdienste muss mindestens 45 betragen.',
    MIN_HOLIDAY_OFFICE_FEE: 'Das Mindesthonorar für Feiertags-Sitzdienste muss mindestens 45 betragen.',
    BREAK_END_BEFORE_START: 'Das Pausenende muss nach dem Pausenbeginn liegen.',
    BREAK_OUTSIDE_SERVICE_PERIOD: 'Die Pause muss innerhalb des Dienstzeitraums liegen.',
    PARTNER_CONTRACT_CONFIRM_NOT_ALLOWED: 'Nur der zugehörige Kunde kann den Vertrag bestätigen.',
    PARTNER_CONFIRMATION_CANNOT_BE_REVOKED: 'Die Bestätigung des Kunden kann nicht zurückgenommen werden.',
    SUBSTITUTE_CONTRACT_CONFIRM_NO_ASSIGNMENT: 'Der Vertrag kann nicht bestätigt werden, da kein Vertreter zugewiesen ist.',
    SUBSTITUTE_CONTRACT_CONFIRM_NOT_ALLOWED: 'Nur der zugewiesene Vertreter kann den Vertrag bestätigen.',
    SERVICE_INFO_ACK_NO_ASSIGNMENT: 'Dienstinformationen können nicht bestätigt werden, da kein Vertreter zugewiesen ist.',
    SERVICE_INFO_ACK_NOT_ALLOWED: 'Nur der zugewiesene Vertreter kann die Dienstinformationen bestätigen.',
    SUBSTITUTE_CONFIRMATION_CANNOT_BE_REVOKED: 'Die Bestätigung des Vertreters kann nicht zurückgenommen werden.',
    ONLY_ASSIGNED_SUBSTITUTE: 'Nur der zugewiesene Vertreter kann Zählungen setzen.',
    ONLY_PARTNER: 'Nur der Kunde kann die Zählungen bestätigen.',
    COUNTS_NOT_SET_BY_SUBSTITUTE: 'Der Kunde kann die Zählungen erst bestätigen, wenn alle vom Vertreter gesetzt wurden.',
    INVALID_ESTABLISHMENT: 'Ungültige Betriebsstätte.',
    ESTABLISHMENT_MISSING_SERVICE_AREA: 'Der Betriebsstätte fehlt ein Dienstgebiet.',
    INVALID_ESTABLISHMENT_DOCTOR: 'Ungültiger Betriebsstättenarzt oder nicht zur Betriebsstätte gehörend.',
    SERVICE_OWN_PARENT: 'Ein Dienst kann nicht sein eigener übergeordneter Dienst sein.',
    INVALID_PARENT_SERVICE: 'Ungültige übergeordnete Dienst-ID.',
    CANNOT_LINK_INVOICED_SERVICE: 'Dienste können nicht verlinkt werden, wenn bereits eine Rechnung ausgestellt wurde.',
    CANNOT_LINK_DIFFERENT_CUSTOMER: 'Dienste können nur verlinkt werden, wenn sie demselben Kunden zugeordnet sind.',
    CANNOT_LINK_DIFFERENT_SUBSTITUTE: 'Dienste können nur verlinkt werden, wenn sie demselben Vertreter zugeordnet sind.',
    SERVICE_NOT_ASSIGNED: 'Dem Dienst wurde kein Vertreter zugewiesen.',
    SERVICE_CANCELLED: 'Der Dienst wurde storniert.',
    RELATED_USER_NOT_FOUND: 'Der zugehörige Benutzer wurde nicht gefunden.',
    DEACTIVATED_SUBSTITUTE: 'Der Vertreter ist deaktiviert.',
    UNSUPPORTED_SERVICE_TYPE: 'Der Diensttyp wird nicht unterstützt.',
    NO_SUBSTITUTE_ASSIGNED: 'Dem Dienst ist kein Vertreter zugewiesen.',
    SERVICE_CONCLUDED: 'Der Dienst wurde bereits abgeschlossen.',
    CANNOT_CANCEL_AFTER_START: 'Der Dienst kann nach Beginn nicht storniert werden, es sei denn, der Grund „Nicht erschienen" wird ausgewählt.',
    SERVICE_ALREADY_CANCELLED: 'Der Dienst wurde bereits aus einem anderen Grund storniert. Bitte entfernen Sie zuerst die vorherige Stornierung.',
    SUBSTITUTE_DID_NOT_APPLY: 'Der Vertreter hat sich nicht auf diesen Dienst beworben.',
    SUBSTITUTE_ALREADY_ASSIGNED: 'Der Vertreter ist diesem Dienst bereits zugewiesen.',
    SERVICE_ALREADY_PUBLISHED: 'Der Dienst wurde bereits veröffentlicht.',
    ACCESS_CODE_EXPIRED: 'Der Registrierungszugangscode ist abgelaufen.',
    INVALID_ACCESS_CODE: 'Ungültiger Registrierungszugangscode.',
    ALREADY_EXISTS: 'Der Eintrag existiert bereits.',
    ALREADY_HAS_PARTNER_ACCESS: 'Der Benutzer hat bereits Zugang zu Kundenfunktionen.',
    ALREADY_HAS_SUBSTITUTE_ACCESS: 'Der Benutzer hat bereits Zugang zu Vertreterfunktionen.',
    AMBIGUOUS_USER_FOR_DEBTOR: 'Mehrdeutiger Benutzer für den Debitor.',
    BAG_HANDLING_FEE_NEGATIVE: 'Die Taschenbearbeitungsgebühr darf nicht negativ sein.',
    BONUS_FEE_NEGATIVE: 'Die Bonusgebühr darf nicht negativ sein.',
    BOOKMARK_ALREADY_EXISTS: 'Das Lesezeichen existiert bereits für diesen Benutzer.',
    BOOKMARK_NOT_BELONGING_TO_USER: 'Das Lesezeichen gehört nicht diesem Benutzer.',
    CANNOT_CANCEL_STARTED_SERVICE: 'Der Dienst kann nach Beginn nicht storniert werden, es sei denn, der Grund „Nicht erschienen" wird ausgewählt.',
    CANNOT_SUBMIT_FOR_OPERATOR: 'Ein Dienst kann nicht für einen Operator eingereicht werden.',
    CERTIFICATE_ALREADY_EXISTS: 'Das Zertifikat für diese Fachspezialisierung existiert bereits.',
    COGNITO_USER_CREATION_FAILED: 'Die Erstellung des Cognito-Benutzers ist fehlgeschlagen.',
    CURRENT_USER_NOT_FOUND: 'Der aktuelle Benutzer wurde nicht gefunden.',
    CURRENT_USER_NOT_IDENTIFIED: 'Der aktuelle Benutzer konnte nicht identifiziert werden.',
    CURRENT_USER_NOT_LOADED: 'Der aktuelle Benutzer konnte nicht geladen werden.',
    CUSTOMER_PROFILE_CANNOT_BE_DELETED: 'Das Kundenprofil kann nicht gelöscht werden.',
    DEBTOR_AMBIGUOUS_INSTITUTION: 'Der Debitor ist mehreren Einrichtungen zugeordnet.',
    DEBTOR_NOT_FOUND: 'Debitor nicht gefunden.',
    DEBTOR_NO_INSTITUTION: 'Der Debitor ist keiner Einrichtung zugeordnet oder die Einrichtung(en) haben keinen Eigentümer.',
    DEBTOR_NO_USER_REFERENCE: 'Der Debitor hat keine Benutzerreferenz.',
    DEBTOR_TARIFF_NOT_FOUND: 'Der Debitortarif wurde nicht gefunden.',
    DOCUMENTS_EMAIL_FAILED: 'Das Senden der Dokumente per E-Mail ist fehlgeschlagen.',
    EMAIL_ALREADY_IN_USE: 'Die E-Mail-Adresse wird bereits verwendet.',
    EMAIL_REQUIRED: 'E-Mail-Adresse ist erforderlich.',
    EMERGENCY_NOTE_SERVICE_ID_NULL: 'Die Dienst-ID der Notfallnotiz ist NULL.',
    ESTABLISHMENT_ALREADY_DELETED: 'Die Betriebsstätte wurde bereits gelöscht.',
    ESTABLISHMENT_DOCTORS_HAVE_ACTIVE_SERVICES: 'Die Betriebsstätte kann nicht gelöscht werden, da Ärzte aktive Dienste haben.',
    ESTABLISHMENT_DOCTOR_ALREADY_DELETED: 'Der Betriebsstättenarzt wurde bereits gelöscht.',
    ESTABLISHMENT_DOCTOR_HAS_ACTIVE_SERVICES: 'Der Betriebsstättenarzt kann nicht gelöscht werden, da er aktive Dienste hat.',
    ESTABLISHMENT_DOCTOR_HAS_SERVICES: 'Der Betriebsstättenarzt kann nicht gelöscht werden, da er von Diensten referenziert wird.',
    ESTABLISHMENT_HAS_ACTIVE_SERVICES: 'Die Betriebsstätte kann nicht gelöscht werden, da sie aktive Dienste hat.',
    ESTABLISHMENT_NOT_FOUND: 'Betriebsstätte nicht gefunden.',
    ESTABLISHMENT_NOT_OWNED: 'Die Betriebsstätte gehört keiner Einrichtung an.',
    ESTABLISHMENT_NOT_OWNED_KV: 'Die Betriebsstätte gehört keiner Einrichtung an (erforderlich für die Neuberechnung der KV-Sitze).',
    ESTABLISHMENT_OWNERSHIP_FETCH_FAILED: 'Der Eigentumsdatensatz der Betriebsstätte konnte nicht abgerufen werden.',
    ESTABLISHMENT_OWNERSHIP_NOT_FOUND: 'Eigentumsdatensatz der Betriebsstätte nicht gefunden.',
    HOLIDAY_MIN_FEE_TOO_LOW: 'Das Mindesthonorar für Feiertage muss mindestens 45 betragen.',
    INSTITUTION_NOT_FOUND: 'Einrichtung nicht gefunden.',
    INSTITUTION_NOT_OWNED: 'Die Einrichtung gehört nicht dem Benutzer.',
    INVALID_BILL_PAYMENT_METHOD: 'Ungültige Rechnungszahlungsmethode.',
    INVALID_BOOKMARK_ID: 'Ungültige Lesezeichen-ID.',
    INVALID_CATEGORY_NAME: 'Ungültiger Kategoriename.',
    INVALID_DEBTOR_ID: 'Ungültige Debitor-ID.',
    INVALID_EMERGENCY_NOTE: 'Ungültige Notfallnotiz.',
    INVALID_EMERGENCY_NOTE_ID: 'Ungültige Notfallnotiz-ID.',
    INVALID_ESTABLISHMENT_DOCTOR_DELETE: 'Ungültiger Betriebsstättenarzt.',
    INVALID_ESTABLISHMENT_DOCTOR_MOBILE: 'Ungültiger Betriebsstättenarzt oder nicht zur Betriebsstätte gehörend (Fahrdienst).',
    INVALID_ESTABLISHMENT_DOCTOR_OFFICE: 'Ungültiger Betriebsstättenarzt oder nicht zur Betriebsstätte gehörend (Sitzdienst).',
    INVALID_ESTABLISHMENT_ID: 'Ungültige Betriebsstätten-ID.',
    INVALID_LIABILITY_INSURANCE_DOC: 'Ungültiges Haftpflichtversicherungsdokument.',
    INVALID_MEASLES_PROOF_DOC: 'Ungültiger Masern-Immunitätsnachweis.',
    INVALID_MESSAGE_IDS: 'Ungültige Nachrichten-IDs.',
    INVALID_PARTNER_USER: 'Ungültiger Kundenbenutzer.',
    INVALID_PAYMENT_PERIOD: 'Ungültige Zahlungsperiode.',
    INVALID_RECIPIENT: 'Ungültiger Empfänger.',
    INVALID_SENDER: 'Ungültiger Absender.',
    INVALID_SEPA_PAYMENT_METHOD: 'Ungültige SEPA-Zahlungsmethode.',
    INVALID_SERVICE_AREA: 'Ungültiges Dienstgebiet.',
    INVALID_SERVICE_AREA_MOBILE: 'Ungültiges Dienstgebiet (Fahrdienst).',
    INVALID_SERVICE_AREA_OFFICE: 'Ungültiges Dienstgebiet (Sitzdienst).',
    INVALID_SERVICE_CANCEL: 'Ungültiger Dienst (Stornierung).',
    INVALID_SERVICE_DELETE: 'Ungültiger Dienst (Löschung).',
    INVALID_SERVICE_DURATION: 'Ungültige Dienstdauer.',
    INVALID_SERVICE_ID: 'Ungültige Dienst-ID.',
    INVALID_SERVICE_LOGISTICS: 'Ungültige Dienstlogistik.',
    INVALID_SERVICE_MESSAGE: 'Ungültiger Dienst (Nachricht).',
    INVALID_SERVICE_OR_SUBSTITUTE: 'Ungültiger Dienst oder Vertreter.',
    INVALID_SERVICE_REVOKE: 'Ungültiger Dienst (Widerruf).',
    INVALID_SPECIALIZATION_ID: 'Ungültige Spezialisierungs-ID.',
    INVALID_SUBMISSION: 'Ungültige Einreichung.',
    INVALID_SUBSTITUTE_ID: 'Ungültige Vertreter-ID.',
    INVALID_SUBSTITUTE_SPECIALIZATION: 'Ungültige Vertreterspezialisierung.',
    INVALID_TARIFF_PERIOD: 'Ungültige Tarifperiode.',
    INVALID_USER: 'Ungültiger Benutzer.',
    INVALID_USER_EMAIL: 'Ungültige Benutzer-E-Mail.',
    INVALID_VALID_FROM_DATE: 'Ungültiges „Gültig ab"-Datum.',
    INVALID_VALID_TO_DATE: 'Ungültiges „Gültig bis"-Datum.',
    KV_SEATS_MINIMUM: 'Die Anzahl der KV-Sitze muss mindestens 0,25 betragen.',
    LICENSE_ALREADY_EXISTS: 'Die Approbation existiert bereits.',
    LOGGED_USER_NOT_FOUND: 'Der angemeldete Benutzer wurde nicht gefunden.',
    LOGGED_USER_NOT_OPERATOR: 'Der angemeldete Benutzer ist kein Operator.',
    MASS_EMAIL_FAILED: 'Das Senden der Massen-E-Mail ist fehlgeschlagen.',
    MESSAGES_DIFFERENT_RECIPIENT: 'Die Nachrichten haben einen anderen Empfänger und können nur vom Empfänger bestätigt werden.',
    MESSAGE_IDS_MUST_BE_ARRAY: 'Nachrichten-IDs müssen ein Array sein.',
    MISSING_ADDRESS: 'Die Adresse, die Sie aktualisieren möchten, existiert nicht.',
    MISSING_APPLICATION: 'Die Bewerbung, die Sie zuweisen möchten, existiert nicht.',
    MISSING_BANK_ACCOUNT: 'Das Bankkonto, das Sie aktualisieren möchten, existiert nicht.',
    MISSING_DEBTOR_ID: 'Keine Debitor-ID angegeben.',
    MISSING_DEBTOR_TARIFF: 'Debitortarifeintrag fehlt.',
    MISSING_MOBILE_SERVICE_ENTRY: 'Fahrdienstein fehlt.',
    MISSING_OFFICE_SERVICE_ENTRY: 'Sitzdienstein fehlt.',
    MISSING_PAYMENT_METHOD_ID: 'Zahlungsmethoden-ID fehlt.',
    MISSING_PAYMENT_PERIOD: 'Zahlungsperiode fehlt.',
    MISSING_PERIOD: 'Periodenargument fehlt.',
    MISSING_PRODUCT_NUMBER: 'Produktnummer fehlt.',
    MISSING_SNS_TOPIC_ARN: 'SNS_TOPIC_ARN Umgebungsvariable fehlt.',
    MISSING_STATE: 'Das Bundesland muss angegeben werden.',
    MISSING_SUBSTITUTE: 'Der Vertreter, den Sie aktualisieren möchten, existiert nicht.',
    MISSING_SUBSTITUTE_ID: 'Vertreter-ID fehlt.',
    MISSING_USER: 'Der zugehörige Benutzer existiert nicht.',
    MISSING_USERPOOL_ID: 'APP_USERPOOL_ID Umgebungsvariable fehlt.',
    MISSING_USERPOOL_WEBCLIENT_ID: 'APP_USERPOOL_WEBCLIENT_ID Umgebungsvariable fehlt.',
    MISSING_USER_ID: 'Benutzer-ID fehlt.',
    MISSING_ZIP_CODE: 'Die Postleitzahl muss angegeben werden.',
    NEWSLETTER_BLACKLIST_ADD_FAILED: 'Das Hinzufügen zur Newsletter-Sperrliste ist fehlgeschlagen.',
    NEWSLETTER_BLACKLIST_REMOVE_FAILED: 'Das Entfernen von der Newsletter-Sperrliste ist fehlgeschlagen.',
    NEWSLETTER_EMAIL_FAILED: 'Das Senden der Newsletter-E-Mail ist fehlgeschlagen.',
    NEWSLETTER_STATE_EMAIL_FAILED: 'Das Senden der Newsletter-E-Mail nach Bundesland ist fehlgeschlagen.',
    NOT_ASSIGNED: 'Der Dienst ist nicht zugewiesen.',
    NOT_AUTHORIZED_CONTRACT: 'Sie sind nicht berechtigt, diesen Vertrag einzusehen.',
    NOT_AUTHORIZED_INVOICE: 'Sie sind nicht berechtigt, diese Rechnung einzusehen.',
    NOT_FOUND: 'Der Dienst wurde nicht gefunden.',
    NO_DOCUMENTS_SELECTED: 'Keine Dokumente ausgewählt.',
    NO_GUEST_USER_FOUND: 'Kein Gastbenutzer gefunden.',
    NO_INSTITUTION_OWNER: 'Kein Eigentümer der Einrichtung gefunden.',
    NO_PERMISSION_UPDATE_LOGISTICS: 'Der Benutzer hat keine Berechtigung, die Dienstlogistik zu aktualisieren.',
    NO_PERMISSION_UPDATE_PARTNER: 'Der Benutzer hat keine Berechtigung, den Kunden zu aktualisieren.',
    ONLY_OPERATORS_CREATE_PARTNER: 'Nur Operatoren können Kundenbenutzer erstellen.',
    ONLY_OPERATORS_CREATE_SUBSTITUTES: 'Nur Operatoren können Vertreter erstellen.',
    ONLY_OPERATORS_DELETE_DOCTORS: 'Nur Operatoren können Betriebsstättenärzte löschen.',
    ONLY_OPERATORS_DELETE_ESTABLISHMENTS: 'Nur Operatoren können Betriebsstätten löschen.',
    ONLY_OPERATORS_SPECIFY_SUBSTITUTE: 'Nur Operatoren können einen Vertreter angeben.',
    ONLY_OPERATORS_SPECIFY_USER: 'Nur Operatoren können eine Benutzer-ID angeben.',
    ONLY_OPERATORS_UPDATE_LEGACY: 'Nur Operatoren können Legacy-Benutzerinformationen aktualisieren.',
    OPERATOR_NOT_FOUND: 'Operator nicht gefunden.',
    OPERATOR_SUBSTITUTE_ID_REQUIRED: 'Operator: Vertreter-ID erforderlich.',
    ORDER_CONFIRMATION_EMAIL_FAILED: 'Das Senden der Auftragsbestätigung per E-Mail ist fehlgeschlagen.',
    ORDER_SUMMARY_EMAIL_FAILED: 'Das Senden der Auftragsübersicht per E-Mail ist fehlgeschlagen.',
    PARTNER_CREATION_FAILED: 'Die Erstellung des Kundenkontos ist fehlgeschlagen.',
    PARTNER_NOT_FOUND_AFTER_UPDATE: 'Der Kunde wurde nach der Aktualisierung nicht gefunden.',
    REGULAR_MIN_FEE_TOO_LOW: 'Das reguläre Mindesthonorar muss mindestens 45 betragen.',
    RELATED_CUSTOMER_NOT_FOUND: 'Der zugehörige Kunde wurde nicht gefunden.',
    SERVICE_AREA_EXPIRED_OR_INACTIVE: 'Das Dienstgebiet ist abgelaufen oder noch nicht aktiv.',
    SERVICE_IS_CANCELLED: 'Der Dienst wurde storniert.',
    SERVICE_IS_CONCLUDED: 'Der Dienst wurde abgeschlossen.',
    SERVICE_LOGISTICS_NOT_FOUND: 'Dienstlogistik nicht gefunden.',
    SERVICE_OWNER_MISSING: 'Der Diensteigentümer fehlt.',
    SHARE_RATES_NON_NEGATIVE: 'Beteiligungssätze dürfen nicht negativ sein.',
    SPECIALIZATION_CERTIFICATE_NOT_FOUND: 'Das Spezialisierungszertifikat wurde nicht gefunden.',
    STATE_NOT_FOUND: 'Das Bundesland wurde nicht gefunden.',
    SUBMITTED_SUBSTITUTE_NOT_FOUND: 'Der eingereichte Vertreter existiert nicht.',
    SUBSTITUTE_CREATION_FAILED: 'Die Erstellung des Vertreters ist fehlgeschlagen.',
    SUBSTITUTE_DEACTIVATED: 'Der Vertreter ist deaktiviert.',
    SUBSTITUTE_NOT_FOUND: 'Der Vertreter wurde nicht gefunden.',
    SUBSTITUTE_NOT_FOUND_AFTER_UPDATE: 'Der Vertreter wurde nach der Aktualisierung nicht gefunden.',
    SUBSTITUTE_PROFILE_CANNOT_BE_DELETED: 'Das Vertreterprofil kann nicht gelöscht werden.',
    SUSPENDED_CONTRACT_FEE_NEGATIVE: 'Die Vertragsaussetzungsgebühr darf nicht negativ sein.',
    UPDATE_ERRORS: 'Bei der Aktualisierung sind Fehler aufgetreten.',
    USER_ALREADY_DEACTIVATED: 'Der Benutzer ist bereits deaktiviert.',
    USER_EMAIL_REQUIRED: 'E-Mail-Adresse des Benutzers ist erforderlich.',
    USER_NOT_DEACTIVATED: 'Der Benutzer ist nicht deaktiviert.',
    USER_NOT_FOUND: 'Der Benutzer wurde nicht gefunden.',
    USER_NOT_FOUND_AFTER_UPDATE: 'Der Benutzer wurde nach der Aktualisierung nicht gefunden.',
    USER_NOT_FOUND_FOR_EMAIL: 'Kein Benutzer für diese E-Mail-Adresse gefunden.',
    USER_NOT_LEGACY: 'Der Benutzer ist kein Legacy-Benutzer.',
    USER_NOT_OPERATOR: 'Der Benutzer ist kein Operator.',
    USER_NOT_SUBSTITUTE: 'Der Benutzer ist kein Vertreter.',
    VALID_FROM_BEFORE_VALID_TO: '„Gültig ab" muss vor „Gültig bis" liegen.',
    CLOSE: 'Schließen',
  },
  SUDO_MODE: {
    BUTTON: 'Sudo Mode',
    WARNING: 'Sudo Mode Aktiv',
  },
  ORDER_CONFIRMATION: {
    GENERATE_ORDER_CONFIRMATION: 'Auftragsbestätigung Erzeugen',
    GENERATE_ORDER_SUMMARY: 'Auftragsübersicht Erzeugen',
    CLOSE: 'Schließen',
    TITLE: 'Auftragsbestätigung',
    VERIFY: 'Bitte schicken Sie die Auftragsbestätigung an:',
    MAIL: 'Mailadresse:',
    OR: 'oder',
    FAX: 'Faxnummer:',
    PERIOD: 'Zeitraum:',
    SERVICE_AREA: 'Dienstgebiet:',
    SUBTITLE: 'Anbei die Liste der Dienste, welche wir in Ihrem Auftrag zur Ausschreibung vorsehen würden.',
    SUBTITLE2: 'Wir bitten Sie, diese Liste auf Vollständigkeit und Richtigkeit zu prüfen.',
    ESTABLISHMENT_NAME: 'Betriebstätte',
    ESTABLISHMENT_ADDRESS: 'Adresse:',
    FROM: 'Von',
    TO: 'Bis',
    LENGTH: 'Dauer',
    SECONDARY_SERVICE_AREA: 'Dienstgebiet',
    TYPE: 'Typ',
    BREAK_BETWEEN: 'Pause zwischen',
  },
  ORDER_SUMMARY: {
    DOWNLOAD: 'Auftragsübersicht runterladen',
    INFO: 'Bitte benutzen Sie bei jedem Dienst das Kartenlesegerät des Kunden, wenn vorhanden. Ansonsten kann es zu Verzögerungen bezüglich der Auszahlung Ihres Honorars kommen.',
    DETAILS: 'Dienste im Detail',
    FROM: 'Von',
    TO: 'Bis',
    TITLE: 'Auftragsübersicht',
  },
  EVENT_LOGS: {
    HEADING: 'Event Log',
    TOGGLE: 'Event Log',
    EVENT_DESCRIPTION: {
      UPDATE_SERVICE: 'hat folgendes geändert:\n{details}',
      UPDATE_SERVICE_LOGISTICS: 'hat den Status auf {status} geändert',
    },
    EVENT_DESCRIPTION_LABELS: {
      kind: 'Dienstart',
      start: 'Dienststart',
      end: 'Dienstende',
      serviceBreakStart: 'Pause von',
      serviceBreakEnd: 'Pause bis',
      regularFeeMin: 'Mindesthonorar',
      regularFeeMax: 'Maximales Honorar',
      regularFeeCurrent: 'Aktuelles Honorar',
      kv_share_rate_m: 'Notfallscheinbeteiligung',
      kv_share_rate_o: 'Notfallscheinbeteiligung',
      state_insured_patient_count: 'Anzahl Gesetztlich Versicherte',
      private_patient_count: 'Anzahl Private Versicherte',
      necropsy_count: 'Anzahl Totenscheine',
      consultation_via_telephone_count: 'Anzahl Telefonischer Beratungen',
      cardreader_info: 'Kartenlesegerät',
      medical_documents_info: 'Medizinische Dokumente',
      misc_info: 'Sonstiges',
    },
    EVENT_TYPES: {
      update_service_logistics: 'Logistikstatus aktualisiert',
      cancel_service: 'Dienst storniert',
      remove_cancel_service: 'Wiederzugewiesen',
      send_notice_contract_documents: 'Dienstvertretungsvertrag und Tauschmeldung verschickt',
      user_registered: 'Nutzer hat sich registriert',
      update_profile: 'Profil aktualisiert',
      partner_role_request: 'Rolle "Kunde" festgelegt',
      substitute_role_request: 'Rolle "Vertreter" festgelegt',
      update_subsitute: 'Vertreterdaten aktualisiert',
      create_application: 'Bewerbung hinzugefügt',
      create_assignment: 'Dienst vergeben',
      revoke_application: 'Bewerbung gelöscht',
      revoke_assignment: 'Dienstzuweisung gelöscht',
      message_read: 'Nachricht gelesen',
      create_office_service: 'Sitzdienst angelegt',
      create_mobile_service: 'Fahrdienst angelegt',
      conclude_service: 'Dienst abgeschlossen',
      substitute_verified: 'Vertreter verifiziert',
      update_service: 'Dienst aktualisiert',
    },
  },
  TAB_LABELS: {
    OPERATOR_SERVICES: 'Dienstverwaltung',
    OPERATOR_SERVICESUBMISSIONS: 'Dienst Submissions',
    OPERATOR_ALLINCLUSIVE_SERVICES: 'Rundum-Sorglos Dienste',
    OPERATOR_TIER_SERVICES: 'Dienste nach Dringlichkeit',
    OPERATOR_SERVICEAREAS: 'Dienstgebiete',
    OPERATOR_SINGLE_SERVICEAREA: 'Dienstgebiet',
    OPERATOR_USERS: 'Nutzerverwaltung',
    OPERATOR_INSURANCES: 'Versicherungen',
    OPERATOR_ACCOUNTING: 'Buchhaltung',
    OPERATOR_REPORTING_REGISTERED_SERVICES: 'Reporting Eingetragene Dienste',
    OPERATOR_REPORTING_REGISTERED_USERS: 'Reporting Registrierte Nutzer',
    OPERATOR_SINGLE_USER: 'Nutzer',
    OPERATOR_SINGLE_SERVICE: 'Dienst',
    OPERATOR_LOGISTICS_HUB: 'Logistik Hub',
  },
  CLOSE_TAB: 'Tab schließen',
  TABLE: {
    ROWS_PER_PAGE: 'Zeilen pro Seite',
    NO_DATA: 'Keine Daten geladen',
    SEPARATOR: 'von',
  },
  CONFIRM: {
    YES: 'Ja',
    NO: 'Nein',
  },
};
